import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { api } from '../../services/api';

const { TextArea } = Input;

const UserPersonaModal = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const payload = {
        name: values.userPersona,
        description: values.description || null,
      };

      const response = await api.createUserPersona(payload);

      if (response.data.success) {
        message.success('User Persona created successfully!');
        form.resetFields();
        onSuccess();
        onCancel();
      }
    } catch (error) {
      console.error('Error creating user persona:', error);
      message.error(error.response?.data?.message || 'Failed to create user persona');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Add New User Persona"
      open={visible}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Create"
      cancelText="Cancel"
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          name="userPersona"
          label="User Persona Name"
          rules={[{ required: true, message: 'Please enter user persona name' }]}
        >
          <Input placeholder="Enter user persona name" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description"
        >
          <TextArea
            rows={4}
            placeholder="Enter description (optional)"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserPersonaModal;

